
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|1435|433|4964)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
